
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MetaModule } from '../modelo/meta/meta.module';

@Injectable({
  providedIn: 'root'
})
export class ReporteService {

  constructor(private http: HttpClient) { }
  
  anios(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?local="+local+"&id_pais="+id_pais); 
  }

  aniosCrecimiento(id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?aniosCre=SI&id_pais="+id_pais); 
  }

  aniosMeta(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localMEA="+local+"&id_pais="+id_pais); 
  }


  guardar(metas:MetaModule[]){
    return this.http.post(environment.apiUrlMaxipan+"report_anio.php",JSON.stringify(metas)); 
  }

  obtenerMeta(local:string,anio:string,anioMeta:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?anioMETA="+anio+"&localMeta="+local+"&anioMetas="+anioMeta+"&id_pais="+id_pais); 
  }

  anioDE(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localDE=1&id_pais="+id_pais); 
  }



  mesesDE(anio:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?anioDE="+anio+"&id_pais="+id_pais); 
  }

  meses(local:string,anio:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?local1="+local+"&anio="+anio+"&id_pais="+id_pais); 
  }

  mesesMeta(local:string,anio:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localME="+local+"&anioME="+anio+"&id_pais="+id_pais); 
  }

  ventaxlocal(local:string,anio:string,mes:string,cat:string,prod:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localV2="+local+"&anioV2="+anio+"&mesV2="+mes+"&catV2="+cat+"&prodV2="+prod+"&id_pais="+id_pais); 
  }

  ventaxlocalMeta(local:string,anio:string,mes:string,cat:string,prod:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?local2="+local+"&anio2="+anio+"&mes2="+mes+"&cat2="+cat+"&prod2="+prod+"&id_pais="+id_pais); 
  }

  metaxlocal(local:string,anio:string,mes:string,cat:string,prod:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?local4="+local+"&anio4="+anio+"&mes4="+mes+"&cat4="+cat+"&prod4="+prod+"&id_pais="+id_pais); 
  }

  detVentaxlocal(local:string,anio:string,mes:string,cat:string,prod:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localD="+local+"&anioD="+anio+"&mesD="+mes+"&catD="+cat+"&prodD="+prod+"&id_pais="+id_pais); 
  }

  detVentaxlocalxMeta(local:string,anio:string,mes:string,cat:string,prod:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localDME="+local+"&anioDME="+anio+"&mesDME="+mes+"&catDME="+cat+"&prodDME="+prod+"&id_pais="+id_pais); 
  }

  metaxLocalDet(local:string,anio:string,mes:string,cat:string,prod:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localMEV="+local+"&anioMEV="+anio+"&mesMEV="+mes+"&catMEV="+cat+"&prodMEV="+prod+"&id_pais="+id_pais); 
  }

  tipoCliente(id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?tipoCliente=1&"+"&id_pais="+id_pais); 
  }
  

  crecimientoVentas(id_pais,mes,anio)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?crecimientoV=1&"+"&id_pais="+id_pais+"&mesV="+mes+"&anioV="+anio); 
  }

  crecimientoVentasFecha(id_pais,anio,fechaincia,fechafin)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?crecimientoF=1&"+"&id_pais="+id_pais+"&fecha_inicia="+fechaincia+"&fecha_fin="+fechafin); 
  }

  crecimientoDevolucionFecha(id_pais,anio,fechaincia,fechafin)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?devolucionF=1&"+"&id_pais="+id_pais+"&fecha_inicia="+fechaincia+"&fecha_fin="+fechafin); 
  }


  decrecimientoDevolucion(id_pais,mes,anio)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?devolucionV=1&"+"&id_pais="+id_pais+"&mesV="+mes+"&anioV="+anio);  
  }

  rankinLocalVenta(anio:string,mes:string,tipo:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?&anioRV="+anio+"&mesRV="+mes+"&tipo="+tipo+"&id_pais="+id_pais); 
  }

  rankinLocalDevolucion(anio:string,mes:string,tipo:string,id_pais)
  {
    console.log(environment.apiUrlMaxipan+"/report_anio.php?&anioRD="+anio+"&mesRD="+mes+"&tipoD="+tipo);
    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?&anioRD="+anio+"&mesRD="+mes+"&tipoD="+tipo+"&id_pais="+id_pais); 
  }

  Devolucion(anio:string,mes:string,tipo:string,local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?&aniodev="+anio+"&mesdev="+mes+"&tipodev="+tipo+"&localdev="+local+"&id_pais="+id_pais); 
  }


  DevolucionDesc(anio:string,mes:string,tipo:string,local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?&aniodec="+anio+"&mesdec="+mes+"&tipodec="+tipo+"&localdesc="+local+"&id_pais="+id_pais); 
  }





  categoriaLocal(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localC="+local+"&cat=1&id_pais="+id_pais); 
  }

  categoriaLocalMeta(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localME="+local+"&catMe=1&id_pais="+id_pais); 
  }

  productoLocal(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localP="+local+"&cat=1&id_pais="+id_pais);  
  }

  productoLocalMeta(local:string,id_pais)
  {

    return this.http.get(environment.apiUrlMaxipan+"/report_anio.php?localMEP="+local+"&id_pais="+id_pais); 
  }
}